module.exports = __webpack_public_path__ + "assets/diners.fbcbd3360f8e3f629cdaa80e93abdb8b.svg";